export const ModalSize = {
    WD25: "wd-25",
    WD50: "wd-50",
    WD80: "wd-80",
    WD100: "wd-100"
};